import React, { useState } from "react";
import { image_proof, view } from "../../assets/img";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const SingleTable = ({ closedTable }) => {
  const [popup, setPopup] = useState(false);
  const [playVideo, setPlayVideo] = useState(false); // state to toggle video playback

  const roles = [
    {
      id: "Admin",
      name: "midhun",
      description: "Full access to all features",
      serialNo: "12345",
      closeDateTime: "2025-10-14 10:30 AM",
      assignBy: "Robert",
      videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ", // YouTube link
      proof: [
        { img: image_proof },
        { img: image_proof },
        { img: image_proof },
        { img: image_proof },
      ],
    },
  ];

  // convert YouTube URL to embeddable format
  const getEmbedUrl = (url) => {
    const videoId = url.split("v=")[1]?.split("&")[0];
    return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  };

  const handleImageClick = (img) => {
    window.open(img, "_blank");
  };

  return (
    <div className="role-table-container my-3 ">
      <table className="role-table">
        <thead>
          <tr>
            <th>Role</th>
            <th>Name</th>
            <th>Description</th>
            {/* <th>Serial No.</th> */}
            <th>
              Close <br /> Date & Time
            </th>
            {/* <th>Assign By</th> */}
            {/* <th>Proof</th> */}
          </tr>
        </thead>
        <tbody>
          {/* {roles.map((role, index) => ( */}
          <tr >
            <td>{closedTable?.closed_by?.role == 1 ? "Super Admin" : closedTable?.closed_by?.role == 2 ? "Inventory" : closedTable?.closed_by?.role == 3 ? "Technical" : closedTable?.closed_by?.role == 4 ? "Regional Manager" : closedTable?.closed_by?.role == 5 ? "Service Engineer" : "-"}</td>
            <td>{closedTable?.closed_by?.name || "-"}</td>
            <td>{closedTable?.closed_remarks || "-"}</td>
            {/* <td>{closedTable?.closed_by?.serialNo}</td> */}
            <td>{closedTable?.closed_at || "-"}</td>
            {/* <td>{closedTable?.assignBy || "-"}</td> */}
            {/* <td>
              <button onClick={() => setPopup(true)} className="cust-btn">
                <img src={view} alt="View" className="editor-btn" />
              </button>
            </td> */}
          </tr>
          {/* ))} */}
        </tbody>
      </table>

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je">
              <p
                className="popup-close-btn"
                onClick={() => {
                  setPopup(false);
                  setPlayVideo(false);
                }}
              >
                <CloseIcon />
              </p>
            </div>

            {/* Video Proof Section */}
            <div className="video-section">
              <label
                style={{ color: "#323691", fontWeight: "bold" }}
                className="d-flex ac-js mb-2"
              >
                Video Proof
              </label>

              <div className="video-proof-box" style={{ cursor: "pointer" }}>
                {!playVideo ? (
                  <div
                    onClick={() => setPlayVideo(true)}
                    className="vedio_proof_play"
                  >
                    <PlayArrowIcon
                      className="play-icon"
                      style={{ color: "#fff", fontSize: "60px" }}
                    />
                  </div>
                ) : (
                  <iframe
                    width="102%"
                    height="200"
                    src={getEmbedUrl(roles[0].videoUrl)}
                    title="Video Proof"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    style={{ borderRadius: "8px" }}
                  ></iframe>
                )}
              </div>
            </div>

            {/* Image Proof Section */}
            <div className="images-section">
              <label
                className="d-flex ac-js my-2"
                style={{
                  color: "#323691",
                  fontWeight: "bold",
                  marginTop: "10px",
                }}
              >
                Image Proof
              </label>
              <div className="d-flex ac-js gap-3 flex-wrap">
                {roles[0].proof.map((p, i) => (
                  <img
                    key={i}
                    src={p.img}
                    className="image_proof"
                    alt={`proof-${i}`}
                    style={{
                      cursor: "pointer",
                      width: "100px",
                      height: "100px",
                      borderRadius: "8px",
                      objectFit: "cover",
                    }}
                    onClick={() => handleImageClick(p.img)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleTable;
